export default __webpack_public_path__ + "static/media/RoboFriends.a978b7e8.PNG";